import { Warning, CheckCircle, LocalShipping } from "@material-ui/icons";

export const getWorkshopAlertConfig = (msg) => {
  // Flujo estable
  if (msg.includes("Flujo de trabajo estable")) {
    return {
      icon: CheckCircle,
      cls: "alert-ok"
    };
  }

  // Alertas de repuestos
  if (
    msg.includes("Posible retraso de repuestos, contacta con proveedor") ||
    msg.includes("Buen momento para hacer pedido")
  ) {
    return {
      icon: LocalShipping,
      cls: "alert-waiting-parts"
    };
  }

  // Resto de alertas
  return {
    icon: Warning,
    cls: "alert-warning"
  };
};